import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

type DetailActionsProps = {
  title: string;
};

export default function DetailActions({ title }: DetailActionsProps) {
  const [favorited, setFavorited] = useState(false);
  const [toast, setToast] = useState("");
  const location = useLocation();

  useEffect(() => {
    if (!toast) return;
    const timer = window.setTimeout(() => setToast(""), 2200);
    return () => window.clearTimeout(timer);
  }, [toast]);

  const handleFavorite = () => {
    setFavorited((prev) => {
      setToast(prev ? "已取消收藏" : "已加入我的收藏（演示）");
      return !prev;
    });
  };

  const handleShare = async () => {
    const url = `${window.location.origin}${location.pathname}`;
    try {
      if (navigator.share) {
        await navigator.share({ title: `${title} - 日韩黄色电影`, url });
        setToast("已唤起系统分享");
        return;
      }
      await navigator.clipboard.writeText(url);
      setToast("影片链接已复制");
    } catch {
      setToast("分享已取消");
    }
  };

  return (
    <>
      <div className="mt-6 flex flex-col sm:flex-row gap-3">
        <button
          type="button"
          onClick={handleFavorite}
          className={`h-11 flex-1 rounded-md text-sm flex items-center justify-center gap-2 cursor-pointer transition-colors whitespace-nowrap ${
            favorited
              ? "bg-primary-500 text-foreground-950"
              : "bg-background-100 border border-background-300/70 text-foreground-800 hover:border-primary-500"
          }`}
        >
          <i className={favorited ? "ri-heart-fill" : "ri-heart-line"} />
          {favorited ? "已收藏" : "收藏影片"}
        </button>
        <button
          type="button"
          onClick={handleShare}
          className="h-11 flex-1 rounded-md bg-background-100 border border-background-300/70 text-sm text-foreground-800 flex items-center justify-center gap-2 cursor-pointer hover:border-accent-500 hover:text-accent-500 transition-colors whitespace-nowrap"
        >
          <i className="ri-share-forward-line" />
          分享
        </button>
      </div>

      {toast && (
        <div className="fixed z-[60] left-1/2 -translate-x-1/2 bottom-8 px-5 py-3 rounded-md bg-accent-500 text-background-50 text-sm fade-in whitespace-nowrap">
          {toast}
        </div>
      )}
    </>
  );
}